import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from 'src/libs/unesp-core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'

export interface ConsentimentoLgpdDTO {
  tipoConsentimento: string
  versaoTermo: string
  hashTermo: string
  sistemaOrigem: string
  detalhes: string
}

@Injectable({ providedIn: 'root' })
export class ConsentimentoLgpdService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  registrar(dto: ConsentimentoLgpdDTO): Observable<void> {
    return this.http
      .post<void>(`${this.baseUrl}/consentimento-lgpd`, dto)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
